const Velocity = require('velocity-animate')
const Hogan = require('hogan.js');
const Viewer = require('./vendor/photovrse/src/main');

const utils = require('./utils');
const CHAPTER_DATA = require('./chapter-data');

const $appWrapper = $('.intro');
const $initIframe = $('#chapter-init').find('.iframe-vr')
const $startBtn = $('.startscreen').find('.btn');
const $startscreen = $('.startscreen');
const $sliderIframe = $('.slider-wrapper-iframe');
const $sliderText = $('.slider-wrapper-text');

const $footer = $('footer');
const $header = $('header');
const $controls = $('.control-type').find('div');
const $volumeWrapper = $('.control-volume');
const $controlsVolume = $volumeWrapper.find('div');

const $pagination = $('.footer-pagination');

const $prevBtn = $('.button-prev');
const $nextBtn = $('.button-next');
const $html = $('html');

const $desktopCTA = $('.desktop-calltoaction');

// argh
const tmplChapterText = Hogan.compile($('#tmpl-chapter-text').html());
const tmplChapterViewer = Hogan.compile($('#tmpl-chapter-viewer').html());

// these are the slides that we created dynamically
let $sliderBodiesTextDynamic = null, $sliderBodiesIframeDynamic = null;
let currentChapter = -1;
let currTranslateX = 0;
let isMuted = true;

let isVideoMode = true;

function init(){

  
  if(!utils.isWebGLSupported()){
    return false;
  }

  if(utils.isMobile) {
    $('.controls').remove();
  }

  // we only set the iframe if the browser supports webgl
  CHAPTER_DATA.forEach((d) => { 
    $pagination.append('<span />');
    // d.vidframe = `${CONFIG.photovrse.api}/?video=${CONFIG.photovrse.base}/${d.vidframe}`;
    // d.iframe = `${CONFIG.photovrse.api}/?image=${CONFIG.photovrse.base}/${d.iframe}`;
  });

  createSlider();
  setDimensions();

  Viewer.init($sliderIframe.find('.photovrse-container').eq(0)[0], { image: 'images/sylt-start-360.jpg', yaw: 110 });
  //$sliderIframe.find('iframe').eq(0).attr('src', isVideoMode ? CHAPTER_DATA[0].vidframe : CHAPTER_DATA[0].iframe)

  if(isVideoMode){
    $controls.removeClass('active');
    $('.controls').find('div[data-control="video"]').addClass('active');
    $volumeWrapper.show();
  }

  //checkChapterInfos();
  bindEvents();
}


function startStory(){
  $html.removeClass('startview-gradient-overlay');
  $desktopCTA.remove();

  Velocity($sliderText.find('.slider-body').eq(0), 'fadeOut', function(){
    currentChapter = 0;

    $sliderText.find('.slider-body').eq(0).remove();
    $pagination.find('span').removeClass('active').eq(currentChapter).addClass('active');
    $html.removeClass('is-startview');
  }, 500);

  gotoChapter(0);
  unmute();
}

function showDetails(){
  const $chapterInfo = $sliderBodiesTextDynamic.eq(currentChapter).find('.chapter-info');
  $chapterInfo.addClass('is-extended');

  $html.addClass('is-detailview');
}

function hideDetails(evt){
  evt.preventDefault();
  evt.stopPropagation();

  const $chapterInfo = $sliderBodiesTextDynamic.eq(currentChapter).find('.chapter-info');
  $chapterInfo.removeClass('is-extended');

  $html.removeClass('is-detailview');
}

function prevChapter(){
  const nextIndex = currentChapter - 1 < 0 ? CHAPTER_DATA.length - 1 : currentChapter - 1;
  gotoChapter(nextIndex);
}

function nextChapter(){
  const nextIndex = currentChapter + 1 > CHAPTER_DATA.length - 1 ? 0 : currentChapter + 1;
  gotoChapter(nextIndex);
}

function gotoChapter(number){
  currentChapter = number;
  currTranslateX = ((currentChapter-1) * window.innerWidth) + window.innerWidth;
  changeChapter();
}

function changeChapter(){
  $('.photovrse-container').empty(); //remove all canvas elements

  Viewer.init($sliderBodiesIframeDynamic.eq(currentChapter)[0], getViewerData(currentChapter));
  //$sliderBodiesIframeDynamic.eq(currentChapter).find('iframe').attr('src', isVideoMode ? CHAPTER_DATA[currentChapter].vidframe : CHAPTER_DATA[currentChapter].iframe);
  
  // $sliderText.css('transform', 'translateX(' + (-currTranslateX + 'px)'))
  // $sliderIframe.css('transform', 'translateX(' + (-currTranslateX + 'px)'))

  Velocity($sliderText, {translateX: -currTranslateX + 'px'}, 400, function() {});
  Velocity($sliderIframe, {translateX: -currTranslateX + 'px'}, 400, function() {});

  $('.info-box').removeClass('active');
  $pagination.find('span').removeClass('active').eq(currentChapter).addClass('active');

  if (isMuted) {
    mute();
  } else {
    unmute();
  }
}

function activateBtn($btn){
  $btn.addClass('active');
}

function deactivateBtn($btn){
  $btn.removeClass('active');
}

function createSlider(){
  CHAPTER_DATA.forEach(appendSlide);
  $sliderBodiesTextDynamic = $sliderText.find('.slider-body.dynamic');
  $sliderBodiesIframeDynamic = $sliderIframe.find('.slider-body.dynamic');
}

function appendSlide(slideData, i){
  let $slide = $(tmplChapterText.render(slideData));
  $slide.width = window.innerWidth + 'px';

  let $slideText = $slide.find('.chapter-info');
  
  $sliderText.append($slide);
  // $slideText.css('height', $slideText.outerHeight() + 'px')

  $slide = $(tmplChapterViewer.render(slideData));
  $slide.width = window.innerWidth + 'px';
  $sliderIframe.append($slide);
}

function bindEvents(){
  $startBtn.on(utils.clickEvent, startStory);
  $prevBtn.on(utils.clickEvent, prevChapter);
  $nextBtn.on(utils.clickEvent, nextChapter);
  $controls.on(utils.clickEvent, handleControl);
  $controlsVolume.on(utils.clickEvent, handleVolume);
  
  $(document).on(utils.clickEvent, '.chapter-detail-btn', showDetails);
  $(document).on(utils.clickEvent, '.chapter-detail-close', hideDetails);
  $(document).on(utils.clickEvent, '.footer-pagination span', gotoPagination);
  $(document).on(utils.clickEvent, '.btn-cardboard', toggleVideo);

  let debounceResize = utils.debounce(resize, 100);
  $(window).on('resize', debounceResize);

  $(document).on('vrmode:on', onVrOn);
  $(document).on('vrmode:off', onVrOff);
}

function onVrOn() {
  $('header,footer,.slider-wrapper-text').hide();
}

function onVrOff() {
  $('header,footer,.slider-wrapper-text').show();
}

function mute() {
  Viewer.mute();
  $volumeWrapper.addClass('active');
  isMuted = true;
}

function unmute() {
  Viewer.unmute();
  $volumeWrapper.removeClass('active');
  isMuted = false;
}

function handleVolume(){
  if($(this).attr('data-volume') === 'on'){
    return unmute();
  }

  return mute();
}

function handleControl(){
  const $this = $(this);
  const type = $this.attr('data-control');

  if($this.hasClass('active')){
    return false;
  }

  $controls.removeClass('active');
  $this.addClass('active');

  // isVideoMode = type === 'video' && !utils.isMobile;

  if(isVideoMode){

    if(!isMuted){
      Viewer.unmute();
    }

    $volumeWrapper.show();
    return toggleVideo();
  }

  Viewer.mute();
  $volumeWrapper.hide();
  // toggleImage();
}

function gotoPagination(){
  gotoChapter($(this).index());
}

function setDimensions(){
  $sliderText.css('width', window.innerWidth * (CHAPTER_DATA.length + 1));
  $sliderIframe.css('width', window.innerWidth * (CHAPTER_DATA.length + 1));

  $('.slider-body').css('width', window.innerWidth);
}

function toggleVideo() {
  $('.photovrse-container').empty();
  Viewer.init($sliderBodiesIframeDynamic.eq(currentChapter)[0], getViewerData(currentChapter));
}   

function toggleImage() {
  $('.photovrse-container').empty();
  Viewer.init($sliderBodiesIframeDynamic.eq(currentChapter)[0], getViewerData(currentChapter));
}

function resize(){
  setDimensions();

  $sliderText.find('.chapter-info').each(el => {
    $(this).css('height', $(this).outerHeight() + 'px');
  });

  if(currentChapter >= 0){
    currTranslateX = ((currentChapter) * window.innerWidth);
  }

  // $sliderText.css('transform', 'translateX(' + (-currTranslateX + 'px)'))
  // $sliderIframe.css('transform', 'translateX(' + (-currTranslateX + 'px)'))

  Velocity($sliderText, { translateX: -currTranslateX + 'px'}, 0, function() {});
  Velocity($sliderIframe, { translateX: -currTranslateX + 'px'}, 0, function() {});

  //checkChapterInfos();
}

function getViewerData(chapterId) {
  const videoSrcKey = utils.isMobile ? 'videoMobile' : 'video';

  return { 
    video: CHAPTER_DATA[chapterId][videoSrcKey],
    yaw: CHAPTER_DATA[chapterId].videoYaw,
    image: CHAPTER_DATA[chapterId].image
  }
}

// extend chapter infos on bigger screens
function checkChapterInfos(){
  $('.chapter-info').toggleClass('is-extended', !utils.isSmallScreen())
}

module.exports = {
  init: init
}